// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Button } from "../../../revvComponents";

// import queryString from "query-string";

// Components Imports
import AddOpportunity from "../../AddOpportunity";
import PipelineOpportunityFilter from "../PipelineOpportunityFilter";
import { ReactWindowList } from "../../../commonComponents";
import withRbac from "../../../app/withRbac";

// Actions Imports
import PipelineActions from "../../../actions/PipelineActions";

// Internal Imports
import { PERMISSIONS, EVENTS } from "../../../constants";
import { OppoUtils, GlobalUtils, AmplitudeUtils } from "../../../utils/index";

// Destructuring
const { getOpportunitiesForPipeline } = PipelineActions;
const { sortOppsDocs, quickFilterOpportunities } = OppoUtils;
const {
  readDataFromLocalStorage,
  writeDataToLocalStorage,
  isFreeTrailBillingPlan,
} = GlobalUtils;

class PipelineLeftFilter extends Component {
  listRef = React.createRef();

  state = {
    sortByOpp: "lastUpdate",
    showAddOppoPopup: false,
    // showShareOppoPopup: false,
    // selectedOppoForShare: {},
  };

  componentDidMount() {
    this._getDocsOfSelectedOpps();

    // This check is required for sharing opportunities, we need to select the shared opportunity when opened via email
    const values = this.parseQuery(window.location.search);
    if (values.oppId) {
      const opportunityId = parseInt(values.oppId, 10);
      // If opportunity id is a string then we dont process the next steps.
      if (Number.isNaN(opportunityId)) {
        return;
      }
      const opportunity = this._searchOpportunityById(opportunityId);
      if (opportunity) {
        this._opportunityClickHandler(opportunity);
      }
    }
  }

  componentDidUpdate() {
    const user = readDataFromLocalStorage("revvsalesUser");
    if (user.opportunityFilter && user.opportunityFilter.id) {
      const opportunityElement = document.getElementById(
        `pipelinewrappercard-opps-list-${user.opportunityFilter.id}`,
      );
      if (opportunityElement) {
        opportunityElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }

  // Temporary fix for parsing query parameters. Need to move to utils.
  parseQuery = str => {
    const s = str.split("&");
    const sLength = s.length;
    const query = {};
    let bit = "";
    let first = "";
    let second = "";
    if (typeof str !== "string" || str.length === 0) return {};
    for (let i = 0; i < sLength; i += 1) {
      bit = s[i].split("=");
      first = decodeURIComponent(bit[0]);
      if (first.length !== 0) {
        second = decodeURIComponent(bit[1]);
        if (typeof query[first] === "undefined") query[first] = second;
        else if (query[first] instanceof Array) query[first].push(second);
        else query[first] = [query[first], second];
      }
    }
    return query;
  };

  _searchOpportunityById = opportunityId => {
    const opportunity = this.props.opportunities.find(
      opp => opp.id === opportunityId,
    );
    return opportunity;
  };

  _getDocsOfSelectedOpps = () => {
    /**
     * Read the LocalStorage for the selected Opportunity("opportunityFilter")
     * & show the pipeline documents of selected Opportunity only
     */
    const user = readDataFromLocalStorage("revvsalesUser");
    if ("opportunityFilter" in user && "name" in user.opportunityFilter) {
      // const opportunity = this.props.opportunities.find(
      //   opp => opp.id === user.opportunityFilter.id,
      // );
      const opportunity = this._searchOpportunityById(
        user.opportunityFilter.id,
      );
      if (opportunity) {
        this._opportunityClickHandler(opportunity);
      }
    }
  };

  // filter documents when click on a opportunity
  _opportunityClickHandler = filter => {
    if (filter.id !== this.props.currentSelectedOpp.id) {
      /**
       * Set the localStorage with current selected Opportunity(as "opportunityFilter")
       * will use this to scroll the current selected opp in the Opportunities lists
       */
      const user = readDataFromLocalStorage("revvsalesUser");
      user.opportunityFilter = { id: filter.id, name: filter.name };
      writeDataToLocalStorage("revvsalesUser", user);
      this.props.getOpportunitiesForPipeline(new Array(filter));
      this.props.updatePipelineState("currentSelectedOpp", filter);
    }
  };

  // Opportunities list handler
  _getOppListItem = () => {
    const { currentSelectedOpp } = this.props;
    const opportunityClickHandler = this._opportunityClickHandler;
    const createDocumentHandler = this._createDocumentHandler;

    const CreateDocBtn = withRbac(({ opportunity }) => (
      <span
        data-test="pipelineleftfilter-opportunity-create-doc-button"
        className="revv-btn create-doc-btn"
        onClick={() => {
          createDocumentHandler(opportunity);
          AmplitudeUtils.amplitudeLogEvent(
            EVENTS.EVENT_NAMES.CREATE_DOC_CLICKED,
            { initiatedFrom: "oppName" },
          );
        }}
        onKeyPress={() => {}}
        role="button"
        tabIndex="-1">
        Create document
      </span>
    ));

    return (style, opportunity) => {
      const isQuuteTableOpp =
        opportunity.external_quotes && opportunity.external_quotes.length > 0;
      let listClassName = "pipelinewrappercard-opps-list ";
      if (isQuuteTableOpp) {
        listClassName += " quote-table-opportunity ";
      }
      if (opportunity.id === currentSelectedOpp.id) {
        listClassName += " active-opp-list";
      }
      return (
        <li
          id={`pipelinewrappercard-opps-list-${opportunity.id}`}
          className={listClassName}
          data-test="pipelineleftfilter-opps-list-item">
          <span
            onClick={() => opportunityClickHandler(opportunity)}
            onKeyPress={() => {}}
            role="button"
            tabIndex="0">
            <span
              className="pipelinewrappercard-opps-crown"
              data-test="pipelineleftfilter-opportunity-crown-icon">
              <FontAwesomeIcon icon={["far", "crown"]} />
            </span>
            {opportunity.name}
          </span>

          <div className="pipelineleftfilter-oppslist-right">
            {isQuuteTableOpp && (
              <span
                data-test="pipelineleftfilter-oppslist-quotefromsalesforce-newtext"
                className="pipelineleftfilter-oppslist-new">
                New
              </span>
            )}
            <span
              className="pipelinewrappercard-opps-count"
              data-test={`pipelineleftfilter-opportunity-doc-count-${opportunity.id}`}>
              {opportunity.docs.length}
            </span>
          </div>

          <div
            className="pipelinewrappercard-opps-actionsitem"
            data-test="pipelineleftfilter-opportunity-createdocument-wrapper">
            {opportunity.scope.write && (
              <CreateDocBtn
                permission={PERMISSIONS.PIPELINE.CREATE_DEALS}
                opportunity={opportunity}
              />
            )}

            {
              // Removed temporarily. Delete later if not required
              //   opportunity.scope.Share && (
              //   <Tooltip
              //     placement="top"
              //     align={{
              //       offset: [0, 4],
              //     }}
              //     overlay="Share Opportunity">
              //     <span
              //       className="btn-icon oppo-share-btn"
              //       onClick={() => this._toggleShareOppoPopup(true, opportunity)}
              //       onKeyPress={() => this._toggleShareOppoPopup(true, opportunity)}
              //       role="button"
              //       tabIndex="0">
              //       <FontAwesomeIcon icon={["fas", "user-friends"]} />
              //     </span>
              //   </Tooltip>
              // )
            }
          </div>
        </li>
      );
    };
  };

  _updateSortBy = sortBy => {
    this.setState({
      sortByOpp: sortBy,
    });
  };

  _toggleAddOppoPopup = state => {
    this.setState({ showAddOppoPopup: state });
  };

  // _toggleShareOppoPopup = (state, oppo) => {
  //   this.setState({ showShareOppoPopup: state, selectedOppoForShare: oppo });
  // };

  _clearPipelineSelection = () => {
    const user = readDataFromLocalStorage("revvsalesUser");
    delete user.opportunityFilter;
    writeDataToLocalStorage("revvsalesUser", user);
    this.props.updatePipelineState("currentSelectedOpp", "");
    this.props.getOpportunitiesForPipeline(this.props.opportunities);
  };

  _createDocumentHandler = opportunity => {
    /**
     * Set the localStorage with current selected Opportunity(as "opportunityFilter")
     * will use this to scroll the current selected opp in the Opportunities lists
     */
    this._clearPipelineSelection();
    const user = readDataFromLocalStorage("revvsalesUser");
    user.opportunityFilter = { id: opportunity.id, name: opportunity.name };
    writeDataToLocalStorage("revvsalesUser", user);
    // Open Create Document Popup
    this.props.openCreateDocumentPopup(opportunity);
  };

  render() {
    const { accounts, searchTerm, opportunities } = this.props;
    const { sortByOpp, showAddOppoPopup } = this.state;

    const opportunityList = sortOppsDocs(
      quickFilterOpportunities(opportunities, searchTerm),
      sortByOpp,
      false,
    );

    let listContainerHeight = window.innerHeight - 190;
    if (isFreeTrailBillingPlan()) {
      listContainerHeight -= 60;
    }

    return (
      <Fragment>
        {showAddOppoPopup && (
          <AddOpportunity
            toggleAddOppoPopup={this._toggleAddOppoPopup}
            showAddOppoPopup={showAddOppoPopup}
            accounts={accounts}
          />
        )}
        {
          //   showShareOppoPopup && (
          //   <OppoSharingPopup
          //     oppo={this.state.selectedOppoForShare}
          //     closePopup={() => this._toggleShareOppoPopup(false)}
          //   />
          // )
        }
        <div
          className="piplinefilter-wrapper"
          data-test="pipelineleftfilter-opportunity-wrapper">
          <div
            className={`clear-selection ${
              searchTerm.length === 0 && !this.props.currentSelectedOpp
                ? "inactive-clear-selection"
                : ""
            } ${
              searchTerm.length !== 0 || this.props.currentSelectedOpp
                ? "active-clear-selection"
                : ""
            }`}>
            <span
              className="pipeline-clear-title"
              data-test="pipelineleftfilter-opportunity-title">
              Opportunites
            </span>
            <span
              className="pipeline-clear-btn"
              onClick={() => {
                this.props.updatePipelineState("searchTerm", "");
                this._clearPipelineSelection();
              }}
              onKeyPress={() => {}}
              role="button"
              disabled={searchTerm.length === 0}
              tabIndex="0">
              <span
                className="clear-selection-text"
                data-test="pipelineleftfilter-opportunity-clear-opp-selection-button">
                Show all
              </span>
            </span>
            {!readDataFromLocalStorage("revvsalesUser").crm_configured && (
              <div className="piplinefilter-dropdown">
                <Tooltip
                  placement="top"
                  overlay="Add New Opportunity"
                  align={{
                    offset: [0, 3],
                  }}>
                  <Button
                    data-test="pipelineleftfilter-opportunity-plus-button"
                    className="add-oppo-btn"
                    disabled={this.state.disableAdd}
                    onClick={() => this._toggleAddOppoPopup(true)}>
                    <i>
                      <FontAwesomeIcon icon={["far", "plus"]} />
                    </i>
                  </Button>
                </Tooltip>
              </div>
            )}
          </div>
          <PipelineOpportunityFilter
            searchTerm={searchTerm}
            sortByOpp={sortByOpp}
            updatePipelineState={this.props.updatePipelineState}
            updateMultiplePipelineState={this.props.updateMultiplePipelineState}
            clearPipelineSelection={this._clearPipelineSelection}
            currentSelectedOpp={this.props.currentSelectedOpp}
            updateSortBy={this._updateSortBy}
          />

          <div
            className="piplinefilter-oppslist"
            data-test="pipelineleftfilter-opportunity-oppslist">
            <ReactWindowList
              listRef={this.listRef}
              itemsList={opportunityList}
              listContainerHeight={listContainerHeight}
              listContainerWidth={280}
              listItemMinHeight={40}
              listItemMaxHeight={55}
              listItemHeightConfig={{ key: "name", length: "35" }}
              getListComponent={this._getOppListItem()}
            />
            {opportunityList.length < 0 && (
              <ul>
                <li key="no_opps">
                  <div className="opps-empty-state">
                    <div className="opps-empty-icon">
                      <i className="opps-empty-icon-front pipelineleftfilter-oppsempty-icon">
                        <FontAwesomeIcon icon={["far", "crown"]} />
                      </i>
                    </div>
                    <span className="opps-empty-text">
                      No Opportunities to show. Time for a{" "}
                      <span
                        className="opps-empty-emoji"
                        role="img"
                        aria-label="emoji">
                        ☕️
                      </span>
                      !
                    </span>
                  </div>
                </li>
              </ul>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { accounts, opportunities } = state.PipelineStore;
  return {
    accounts,
    opportunities,
  };
};

const mapDispatchToProps = {
  getOpportunitiesForPipeline: payload => getOpportunitiesForPipeline(payload),
};

export default connect(mapStateToProps, mapDispatchToProps)(PipelineLeftFilter);
